
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptBOMGrid extends Serenity.EntityGrid<JobWorkReceiptBOMRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkReceiptBOM'; }
        protected getDialogType() { return JobWorkReceiptBOMDialog; }
        protected getIdProperty() { return JobWorkReceiptBOMRow.idProperty; }
        protected getInsertPermission() { return JobWorkReceiptBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReceiptBOMRow.localTextPrefix; }
        protected getService() { return JobWorkReceiptBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}